import { Component, Input, OnInit } from '@angular/core';
import { NavService } from '../../../services/nav.service';
import { NavItemService } from './sidebar-data';
import { NavItem } from './nav-item/nav-item';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
})
export class SidebarComponent implements OnInit {

  @Input("onlyIcon")
  onlyIcon?: boolean = false;

  navItems: NavItem[];

  constructor(public navService: NavService,
    private navItemService: NavItemService,
  ) {

  }

  ngOnInit(): void {
    this.load();
  }

  async load() {
    
    this.navItems = await this.navItemService.getTranslatedNavItems();

  }
}
